import { all, call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import * as actions from "../slices/ConsultationSlice";
import { constants } from "../../constants/common";
import { common } from "../../types";
import API from "../../services/rest/api";

const GetUpcomingConsultationsRequest = function* GetUpcomingConsultationsRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientConsultations,
      {
        ...action.payload,
        filter: "upcoming",
        // The stats and rating aggregates describe the whole history, so they
        // ride on this call rather than the paged one.
        include_summary: true,
      }
    );

    if (Number(response.code) === 1) {
      yield put(actions.getUpcomingConsultationsSuccess(response));
      return;
    }

    // Samples from BE use `msg` where the live endpoint sends `message`; read
    // whichever arrived rather than betting on one.
    const ErrorMessage =
      response.message ||
      (response as any).msg ||
      constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getUpcomingConsultationsError(ErrorMessage));
  } catch (error) {
    const ErrorMessage =
      error instanceof Error
        ? error?.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getUpcomingConsultationsError(ErrorMessage));
    toast.error(ErrorMessage);
  }
};

const GetPastConsultationsRequest = function* GetPastConsultationsRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientConsultations,
      {
        page_no: 1,
        ...action.payload,
        filter: "past",
      }
    );

    if (Number(response.code) === 1) {
      yield put(actions.getPastConsultationsSuccess(response));
      return;
    }

    // Samples from BE use `msg` where the live endpoint sends `message`; read
    // whichever arrived rather than betting on one.
    const ErrorMessage =
      response.message ||
      (response as any).msg ||
      constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getPastConsultationsError(ErrorMessage));
  } catch (error) {
    const ErrorMessage =
      error instanceof Error
        ? error?.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getPastConsultationsError(ErrorMessage));
    toast.error(ErrorMessage);
  }
};

export default function* consultationSaga() {
  yield all([
    // takeLatest, not takeEvery: switching the category filter quickly should
    // land on the last selection, not whichever response arrives last.
    takeLatest(
      actions.getUpcomingConsultationsRequest,
      GetUpcomingConsultationsRequest
    ),
    takeLatest(actions.getPastConsultationsRequest, GetPastConsultationsRequest),
  ]);
}
